module.exports = __webpack_public_path__ + "img/20191028190529.8ce752b9.png";